// import { useState, useEffect } from "react";
// import { WorkOrderApi } from "api/workorders/service";
// import { ProjectApi } from "api/projects/service";
// import { format } from "date-fns";
// import {
//   Calendar as CalendarIcon,
//   Plus,
//   Trash2,
//   Upload,
//   FileText,
//   Check,
//   CheckCircle2,
//   AlertCircle,
//   IndianRupee,
//   PartyPopper,
//   X,
// } from "lucide-react";

// // Simple utility to join classes
// const cn = (...classes) => classes.filter(Boolean).join(" ");

// const STEPS = [
//   { id: 1, name: "Basic Info", icon: FileText },
//   { id: 2, name: "Scope", icon: FileText },
//   { id: 3, name: "Payment", icon: IndianRupee },
//   { id: 4, name: "Approval", icon: Check },
// ];

// // Hardcoded sites removed - now using dynamic data

// export function CreateWorkOrderDialog({
//   open,
//   onOpenChange,
//   contractors,
//   selectedContractorId,
//   onCreateWorkOrder,
// }) {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [showSuccess, setShowSuccess] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [apiError, setApiError] = useState(null);
//   const [sites, setSites] = useState([]);
//   const [validationError, setValidationError] = useState(null);

//   // Step 1 - Basic Info
//   const [selectedContractor, setSelectedContractor] = useState(selectedContractorId || "");
//   const [selectedProject, setSelectedProject] = useState("");
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [contractType, setContractType] = useState("Lumpsum");

//   // Step 2 - Scope & Items
//   const [scopeItems, setScopeItems] = useState([
//     { id: "1", item: "", description: "", quantity: 0, unit: "Nos", unitCost: 0, totalCost: 0 },
//   ]);
//   const [scopeNotes, setScopeNotes] = useState("");

//   // Step 3 - Payment Structure
//   const [paymentStructure, setPaymentStructure] = useState("Milestone");
//   const [milestones, setMilestones] = useState([
//     { id: "1", name: "M1", description: "", percentage: 100, value: 0, status: "Pending" },
//   ]);
//   const [monthlyValue, setMonthlyValue] = useState(0);
//   const [retentionPercent, setRetentionPercent] = useState(0);
//   const [paymentTerms, setPaymentTerms] = useState("");
//   const [paymentMode, setPaymentMode] = useState("Bank Transfer"); // Unused in UI but kept for state consistency
//   const [paymentStartDate, setPaymentStartDate] = useState("");

//   // Step 4 - Approval
//   const [acknowledged, setAcknowledged] = useState(false);
//   const [acknowledgmentDate, setAcknowledgmentDate] = useState("");
//   const [attachment, setAttachment] = useState(null);

//   const organization = JSON.parse(localStorage.getItem("organization")) || {};

//   useEffect(() => {
//     const fetchSites = async () => {
//       if (!organization?.id) return;
//       try {
//         const response = await ProjectApi.listSitesByOrganization(organization.id);
//         if (response) {
//           setSites(response || []);
//         }
//       } catch (err) {
//         console.error("Error fetching sites:", err);
//       }
//     };
//     if (open) {
//       fetchSites();
//     }
//   }, [open, organization.id]);

//   const grandTotal = scopeItems.reduce((sum, item) => sum + item.totalCost, 0);
//   const totalMilestonePercent = milestones.reduce((sum, m) => sum + m.percentage, 0);

//   const generateWorkOrderRef = () => {
//     const project = sites.find(p => p.id === selectedProject);
//     const projectName = project?.site_name?.replace(/\s+/g, "_") || "Project";
//     return `WO_${projectName}_${Date.now().toString().slice(-4)}`;
//   };

//   const handleScopeItemChange = (id, field, value) => {
//     setScopeItems(items =>
//       items.map(item => {
//         if (item.id === id) {
//           const updated = { ...item, [field]: value };
//           if (field === "quantity" || field === "unitCost") {
//             updated.totalCost = updated.quantity * updated.unitCost;
//           }
//           return updated;
//         }
//         return item;
//       })
//     );
//   };

//   const addScopeItem = () => {
//     setScopeItems([
//       ...scopeItems,
//       { id: Date.now().toString(), item: "", description: "", quantity: 0, unit: "Nos", unitCost: 0, totalCost: 0 },
//     ]);
//   };

//   const removeScopeItem = (id) => {
//     if (scopeItems.length > 1) {
//       setScopeItems(scopeItems.filter(item => item.id !== id));
//     }
//   };

//   const handleMilestoneChange = (id, field, value) => {
//     setMilestones(items =>
//       items.map(item => {
//         if (item.id === id) {
//           const updated = { ...item, [field]: value };
//           if (field === "percentage") {
//             updated.value = (grandTotal * Number(value)) / 100;
//           }
//           return updated;
//         }
//         return item;
//       })
//     );
//   };

//   const addMilestone = () => {
//     const currentLength = milestones.length;
//     const newIndex = currentLength + 1;

//     if (currentLength === 0) {
//       setMilestones([
//         {
//           id: Date.now().toString(),
//           name: "M1",
//           description: "",
//           percentage: 100,
//           value: grandTotal,
//           status: "Pending",
//         },
//       ]);
//       return;
//     }

//     const ratio = currentLength / newIndex;

//     const updatedMilestones = milestones.map((m) => {
//       const newPercentage = Math.round(m.percentage * ratio);
//       return {
//         ...m,
//         percentage: newPercentage,
//         value: (grandTotal * newPercentage) / 100,
//       };
//     });

//     const currentSum = updatedMilestones.reduce((sum, m) => sum + m.percentage, 0);
//     const newPercentage = 100 - currentSum;

//     setMilestones([
//       ...updatedMilestones,
//       {
//         id: Date.now().toString(),
//         name: `M${newIndex}`,
//         description: "",
//         percentage: newPercentage,
//         value: (grandTotal * newPercentage) / 100,
//         status: "Pending",
//       },
//     ]);
//   };

//   const removeMilestone = (id) => {
//     if (milestones.length > 1) {
//       setMilestones(milestones.filter(m => m.id !== id));
//     }
//   };

//   const handleNext = () => {
//     setValidationError(null);
//     setApiError(null);

//     if (currentStep === 1) {
//       if (!startDate || !endDate) {
//         setValidationError("Please select both Start and End dates.");
//         return;
//       }
//       if (!selectedProject) {
//         setValidationError("Please select a Project before proceeding.");
//         return;
//       }
//     }

//     if (currentStep === 2) {
//       const hasValidItem = scopeItems.some(item => item.item && item.totalCost > 0);
//       if (!hasValidItem) {
//         setValidationError("Please add at least one scope item with a positive total.");
//         return;
//       }
//     }

//     if (currentStep < 4) {
//       setCurrentStep(currentStep + 1);
//     }
//   };

//   const handleBack = () => {
//     if (currentStep > 1) {
//       setCurrentStep(currentStep - 1);
//     }
//   };

//   const handleSubmit = async () => {
//     setIsSubmitting(true);
//     setApiError(null);

//     try {
//       const formData = new FormData();

//       // Mapping constants
//       const paymentStructureMap = {
//         'Milestone': 'MILESTONE_BASED',
//         'Monthly': 'MONTHLY_RUNNING_BILL',
//         'Fixed Price': 'LUMPSUM_CUSTOM',
//       };

//       const contractTypeMap = {
//         'Labour': 'LABOUR',
//         'Item Rate': 'ITEM_RATE',
//         'Lumpsum': 'LUMPSUM',
//       };

//       const paymentModeMap = {
//         'Cash': 'CASH',
//         'Cheque': 'CHEQUE',
//         'Online': 'ONLINE',
//         'Bank Transfer': 'BANK_TRANSFER',
//         'UPI': 'UPI', // Added as it was in the select but not in my initial research mapping
//       };

//       formData.append('contractor', selectedContractor);
//       formData.append('site', selectedProject);
//       formData.append('start_date', startDate);
//       formData.append('end_date', endDate);
//       formData.append('contract_type', contractTypeMap[contractType] || contractType);
//       formData.append('scope_notes', scopeNotes);
//       formData.append('payment_structure', paymentStructureMap[paymentStructure] || paymentStructure);
//       // formData.append('payment_start_date', paymentStartDate);
//       formData.append('payment_terms', paymentTerms);
//       // formData.append('preferred_payment_mode', paymentModeMap[paymentMode] || paymentMode);
//       formData.append('terms_and_conditions', ""); // Could be added to UI later
//       formData.append('date_of_issue', new Date().toISOString().split('T')[0]);
//       formData.append('is_acknowledged', acknowledged);

//       // Map scope items
//       const mappedScopeItems = scopeItems.map(item => ({
//         item_name: item.item,
//         description: item.description,
//         quantity: item.quantity,
//         unit: item.unit.toLowerCase().replace(' ', '_'),
//         unit_cost: item.unitCost,
//         total_price: item.totalCost
//       }));
//       formData.append('scope_items', JSON.stringify(mappedScopeItems));

//       // Map milestones if applicable
//       if (paymentStructure === "Milestone" || paymentStructure === "Lumpsum") {
//         const mappedMilestones = milestones.map(m => ({
//           name: m.name,
//           description: m.description,
//           amount: (grandTotal * m.percentage) / 100
//         }));
//         formData.append('milestones', JSON.stringify(mappedMilestones));
//       }

//       if (attachment) {
//         formData.append('attachments', attachment);
//       }

//       const response = await WorkOrderApi.create(formData);

//       if (response.status) {
//         onCreateWorkOrder(selectedContractor);
//         setShowSuccess(true);
//       } else {
//         setApiError(response.message || "Failed to create work order");
//       }
//     } catch (err) {
//       console.error("Error creating work order:", err);
//       setApiError(err.message || "An unexpected error occurred");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleClose = () => {
//     setCurrentStep(1);
//     setShowSuccess(false);
//     setApiError(null);
//     setIsSubmitting(false);
//     setSelectedContractor(selectedContractorId || "");
//     setSelectedProject("");
//     setStartDate("");
//     setEndDate("");
//     setContractType("Lumpsum");
//     setScopeItems([{ id: "1", item: "", description: "", quantity: 0, unit: "Nos", unitCost: 0, totalCost: 0 }]);
//     setPaymentStructure("Milestone");
//     setAcknowledged(false);
//     onOpenChange(false);
//   };

//   const formatCurrency = (amount) => {
//     if (amount >= 100000) {
//       return `₹${(amount / 100000).toFixed(2)}L`;
//     }
//     return `₹${amount.toLocaleString()}`;
//   };

//   const durationMonths = startDate && endDate
//     ? Math.ceil((new Date(endDate).getTime() - new Date(startDate).getTime()) / (1000 * 60 * 60 * 24 * 30))
//     : 0;

//   // Custom helper components
//   const Label = ({ children, className = "" }) => (
//     <label className={`text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 ${className}`}>{children}</label>
//   );

//   const Input = ({ className = "", ...props }) => (
//     <input className={`flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 ${className}`} {...props} />
//   );

//   const Button = ({ variant = "default", size = "default", className = "", children, ...props }) => {
//     const baseStyles = "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50";
//     const variants = {
//       default: "bg-sm-primary text-white shadow hover:bg-sm-primary/90",
//       destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
//       outline: "border border-input bg-transparent shadow-sm hover:bg-sm-accent hover:text-sm-accent-foreground",
//       secondary: "bg-sm-secondary text-sm-secondary-foreground shadow-sm hover:bg-sm-secondary/80",
//       ghost: "hover:bg-sm-accent hover:text-sm-accent-foreground",
//       link: "text-sm-primary underline-offset-4 hover:underline",
//     };
//     const sizes = {
//       default: "h-9 px-4 py-2",
//       sm: "h-8 rounded-md px-3 text-xs",
//       lg: "h-10 rounded-md px-8",
//       icon: "h-9 w-9",
//     };
//     return (
//       <button className={cn(baseStyles, variants[variant], sizes[size], className)} {...props}>
//         {children}
//       </button>
//     );
//   };

//   if (!open) return null;

//   if (showSuccess) {
//     return (
//       <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80">
//         <div className="relative w-full max-w-md rounded-lg border bg-background p-6 shadow-lg animate-in fade-in-0 zoom-in-95 duration-200">
//           <button onClick={handleClose} className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-sm-accent data-[state=open]:text-muted-foreground">
//             <X className="h-4 w-4" />
//             <span className="sr-only">Close</span>
//           </button>
//           <div className="flex flex-col items-center justify-center py-8 text-center">
//             <div className="h-16 w-16 rounded-full bg-sm-primary/10 flex items-center justify-center mb-4">
//               <PartyPopper className="h-8 w-8 text-sm-primary" />
//             </div>
//             <h2 className="text-xl font-semibold mb-2">Work Order Created Successfully!</h2>
//             <p className="text-muted-foreground text-sm mb-6">
//               Work Order #{generateWorkOrderRef()} has been activated.
//             </p>
//             <div className="flex gap-3">
//               <Button variant="outline" onClick={handleClose}>
//                 Go to Dashboard
//               </Button>
//               <Button onClick={handleClose} className="bg-sm-primary hover:bg-sm-primary/90">
//                 View Work Order
//               </Button>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80">
//       <div className="relative w-full max-w-4xl max-h-[90vh] flex flex-col rounded-lg border bg-background shadow-lg animate-in fade-in-0 zoom-in-95 duration-200">
//         <div className="flex flex-col space-y-1.5 p-6 pb-4 border-b">
//           <div className="flex items-center justify-between">
//             <h3 className="text-lg font-semibold leading-none tracking-tight">Create Work Order</h3>
//             <button onClick={handleClose} className="rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-sm-accent data-[state=open]:text-muted-foreground">
//               <X className="h-4 w-4" />
//               <span className="sr-only">Close</span>
//             </button>
//           </div>

//           {/* Progress Steps */}
//           <div className="flex items-start justify-between mt-4 px-12">
//             {STEPS.map((step, index) => (
//               <div key={step.id} className={cn("flex items-center", index < STEPS.length - 1 ? "flex-1" : "")}>
//                 <div className="flex flex-col items-center relative">
//                   <div
//                     className={cn(
//                       "h-8 w-8 rounded-full flex items-center justify-center text-xs font-medium transition-colors relative z-10",
//                       currentStep > step.id
//                         ? "bg-sm-primary text-white"
//                         : currentStep === step.id
//                           ? "bg-sm-secondary text-white"
//                           : "bg-muted text-muted-foreground"
//                     )}
//                   >
//                     {currentStep > step.id ? <Check className="h-4 w-4" /> : step.id}
//                   </div>
//                   <span
//                     className={cn(
//                       "text-[10px] mt-1 absolute top-8 whitespace-nowrap",
//                       currentStep >= step.id ? "text-foreground" : "text-muted-foreground"
//                     )}
//                   >
//                     {step.name}
//                   </span>
//                 </div>
//                 {index < STEPS.length - 1 && (
//                   <div
//                     className={cn(
//                       "flex-1 h-0.5 -mt-1",
//                       currentStep > step.id ? "bg-sm-primary" : "bg-border"
//                     )}
//                   />
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>

//         <div className="flex-1 overflow-y-auto py-4 px-6">
//           {/* Step 1 - Basic Information */}
//           {currentStep === 1 && (
//             <div className="space-y-6">
//               <div className="space-y-1">
//                 <h3 className="text-sm font-medium text-muted-foreground">Work Order Details</h3>
//                 <div className="grid grid-cols-2 gap-4 pt-2">
//                   <div className="space-y-2">
//                     <Label className="text-xs">Select Contractor</Label>
//                     <select
//                       className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
//                       value={selectedContractor}
//                       onChange={(e) => setSelectedContractor(e.target.value)}
//                     >
//                       <option value="" disabled>Choose contractor</option>
//                       {contractors.map(contractor => (
//                         <option key={contractor.id} value={contractor.id}>
//                           {contractor.name} ({contractor.category})
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <div className="space-y-2">
//                     <Label className="text-xs">Select Project</Label>
//                     <select
//                       className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
//                       value={selectedProject}
//                       onChange={(e) => setSelectedProject(e.target.value)}
//                     >
//                       <option value="" disabled>Choose project</option>
//                       {sites.map(site => (
//                         <option key={site.id} value={site.id}>
//                           {site.site_name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>
//               </div>

//               <div className="space-y-1">
//                 <h3 className="text-sm font-medium text-muted-foreground">Duration</h3>
//                 <div className="grid grid-cols-2 gap-4 pt-2">
//                   <div className="space-y-2">
//                     <Label className="text-xs">Start Date</Label>
//                     <div className="relative">
//                       <input
//                         type="date"
//                         className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
//                         value={startDate}
//                         onChange={(e) => setStartDate(e.target.value)}
//                       />
//                     </div>
//                   </div>
//                   <div className="space-y-2">
//                     <Label className="text-xs">End Date</Label>
//                     <div className="relative">
//                       <input
//                         type="date"
//                         className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
//                         value={endDate}
//                         onChange={(e) => setEndDate(e.target.value)}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* <div className="space-y-1">
//                 <h3 className="text-sm font-medium text-muted-foreground">Contract Type</h3>
//                 <div className="flex gap-4 pt-2">
//                   {["Labour", "Item Rate", "Lumpsum"].map(type => (
//                     <div key={type} className="flex items-center space-x-2">
//                       <input
//                         type="radio"
//                         id={type}
//                         name="contractType"
//                         value={type}
//                         checked={contractType === type}
//                         onChange={(e) => setContractType(e.target.value)}
//                         className="aspect-square h-4 w-4 rounded-full border border-primary text-sm-primary focus:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
//                       />
//                       <Label htmlFor={type} className="text-sm cursor-pointer font-normal">
//                         {type}
//                       </Label>
//                     </div>
//                   ))}
//                 </div>
//               </div> */}
//               {/*
//               <div className="bg-muted/30 rounded-lg p-4">
//                 <div className="flex items-center gap-2 text-sm">
//                   <FileText className="h-4 w-4 text-sm-secondary" />
//                   <span className="font-medium">Work Order Reference:</span>
//                   <span className="inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors font-mono">
//                     {generateWorkOrderRef()}
//                   </span>
//                 </div>
//               </div> */}
//             </div>
//           )}

//           {/* Step 2 - Scope & Items */}
//           {currentStep === 2 && (
//             <div className="space-y-4">
//               <div className="space-y-1">
//                 <h3 className="text-sm font-medium text-muted-foreground">Scope Items</h3>
//               </div>

//               <div className="rounded-lg border bg-white text-card-foreground shadow-sm">
//                 <div className="p-0">
//                   <table className="w-full caption-bottom text-sm">
//                     <thead className="[&_tr]:border-b">
//                       <tr className="border-b transition-colors hover:bg-transparent">
//                         <th className="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs w-[140px]">Item</th>
//                         <th className="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs">Description</th>
//                         <th className="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs w-[100px]">Qty</th>
//                         <th className="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs w-[100px]">Unit</th>
//                         <th className="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs w-[100px]">Unit Cost</th>
//                         <th className="h-10 px-4 align-middle font-medium text-muted-foreground text-xs w-[80px] text-right">Total</th>
//                         <th className="h-10 px-4 text-left align-middle font-medium text-muted-foreground w-[40px]"></th>
//                       </tr>
//                     </thead>
//                     <tbody className="[&_tr:last-child]:border-0">
//                       {scopeItems.map((item, index) => (
//                         <tr key={item.id} className="border-b transition-colors hover:bg-muted/30">
//                           <td className="p-2 align-middle">
//                             <input
//                               value={item.item}
//                               onChange={(e) => handleScopeItemChange(item.id, "item", e.target.value)}
//                               className="flex h-8 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
//                               placeholder="Item name"
//                             />
//                           </td>
//                           <td className="p-2 align-middle">
//                             <input
//                               value={item.description}
//                               onChange={(e) => handleScopeItemChange(item.id, "description", e.target.value)}
//                               className="flex h-8 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
//                               placeholder="Description"
//                             />
//                           </td>
//                           <td className="p-2 align-middle">
//                             <input
//                               type="number"
//                               value={item.quantity || ""}
//                               onChange={(e) => handleScopeItemChange(item.id, "quantity", Number(e.target.value))}
//                               className="flex h-8 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
//                             />
//                           </td>
//                           <td className="p-2 align-middle">
//                             <select
//                               className="flex h-8 w-full rounded-md border border-input bg-background px-3 py-1 text-xs shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
//                               value={item.unit}
//                               onChange={(e) => handleScopeItemChange(item.id, "unit", e.target.value)}
//                             >
//                               <option value="Nos">Nos</option>
//                               <option value="Sqft">Sqft</option>
//                               <option value="Rft">Rft</option>
//                               <option value="Cum">Cum</option>
//                               <option value="Kg">Kg</option>
//                             </select>
//                           </td>
//                           <td className="p-2 align-middle">
//                             <input
//                               type="number"
//                               value={item.unitCost || ""}
//                               onChange={(e) => handleScopeItemChange(item.id, "unitCost", Number(e.target.value))}
//                               className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
//                               placeholder="₹0"
//                             />
//                           </td>
//                           <td className="p-2 align-middle text-right text-sm font-medium">
//                             {formatCurrency(item.totalCost)}
//                           </td>
//                           <td className="p-2 align-middle">
//                             <Button
//                               variant="ghost"
//                               size="icon"
//                               className="h-7 w-7"
//                               onClick={() => removeScopeItem(item.id)}
//                               disabled={scopeItems.length === 1}
//                             >
//                               <Trash2 className="h-3.5 w-3.5 text-destructive" />
//                             </Button>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>

//               <Button variant="ghost" onClick={addScopeItem} className="text-sm-primary text-sm gap-2">
//                 <Plus className="h-4 w-4" />
//                 Add Item
//               </Button>

//               <div className="flex justify-end">
//                 <div className="bg-sm-primary/5 rounded-lg px-6 py-3 border border-primary/20">
//                   <div className="flex items-center gap-3">
//                     <span className="text-sm text-muted-foreground">Grand Total:</span>
//                     <span className="text-lg font-semibold text-sm-primary">{formatCurrency(grandTotal)}</span>
//                   </div>
//                 </div>
//               </div>

//               <div className="space-y-2 pt-4 border-t">
//                 <Label className="text-xs text-muted-foreground">Notes / Special Conditions</Label>
//                 <textarea
//                   value={scopeNotes}
//                   onChange={(e) => setScopeNotes(e.target.value)}
//                   placeholder="Add any special conditions or notes..."
//                   className="flex min-h-[80px] w-full rounded-md border border-input bg-transparent px-3 py-2 shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 text-sm h-20"
//                 />
//               </div>

//               <div className="flex items-center gap-2 pt-2">
//                 {!attachment ? (
//                   <div className="w-full">
//                     <label className="flex flex-col items-center justify-center w-full h-24 border-2 border-dashed border-muted-foreground/25 rounded-lg cursor-pointer hover:bg-muted/30 transition-colors">
//                       <div className="flex flex-col items-center justify-center pt-5 pb-6">
//                         <Upload className="h-6 w-6 text-muted-foreground mb-2" />
//                         <p className="text-xs text-muted-foreground">Click to upload Scope Document (PDF, Image, etc.)</p>
//                       </div>
//                       <input
//                         type="file"
//                         className="hidden"
//                         onChange={(e) => setAttachment(e.target.files[0])}
//                       />
//                     </label>
//                   </div>
//                 ) : (
//                   <div className="w-full bg-sm-primary/5 border border-sm-primary/20 rounded-lg p-3">
//                     <div className="flex items-center gap-4">
//                       {attachment.type.startsWith('image/') ? (
//                         <div className="h-16 w-16 rounded border bg-white overflow-hidden flex-shrink-0">
//                           <img
//                             src={URL.createObjectURL(attachment)}
//                             alt="Preview"
//                             className="h-full w-full object-cover"
//                           />
//                         </div>
//                       ) : (
//                         <div className="h-16 w-16 rounded border bg-white flex items-center justify-center flex-shrink-0">
//                           <FileText className="h-8 w-8 text-sm-primary/40" />
//                         </div>
//                       )}
//                       <div className="flex-1 min-w-0">
//                         <p className="text-sm font-medium truncate">{attachment.name}</p>
//                         <p className="text-xs text-muted-foreground mt-0.5">
//                           {(attachment.size / (1024 * 1024)).toFixed(2)} MB • {attachment.type.split('/')[1]?.toUpperCase() || 'File'}
//                         </p>
//                         <div className="flex items-center gap-2 mt-2">
//                           <span className="flex items-center gap-1 text-[10px] text-green-600 bg-green-50 px-1.5 py-0.5 rounded border border-green-100 font-medium">
//                             <Check className="h-3 w-3" /> Uploaded Successfully
//                           </span>
//                         </div>
//                       </div>
//                       <Button
//                         variant="ghost"
//                         size="icon"
//                         className="h-8 w-8 text-muted-foreground hover:text-destructive"
//                         onClick={() => setAttachment(null)}
//                       >
//                         <X className="h-4 w-4" />
//                       </Button>
//                     </div>
//                   </div>
//                 )}

//               </div>
//             </div>
//           )}

//           {/* Step 3 - Payment Structure */}
//           {currentStep === 3 && (
//             <div className="space-y-6">
//               <div className="space-y-1">
//                 <h3 className="text-sm font-medium text-muted-foreground">Payment Structure Type</h3>
//                 <div className="flex gap-4 pt-2">
//                   {["Milestone", "Monthly", "Fixed Price"].map(type => (
//                     <div
//                       key={type}
//                       className={cn(
//                         "flex items-center space-x-2 border rounded-lg px-4 py-2 cursor-pointer transition-colors",
//                         paymentStructure === type ? "border-primary bg-sm-primary/5" : "border-border"
//                       )}
//                       onClick={() => setPaymentStructure(type)}
//                     >
//                       <input
//                         type="radio"
//                         id={`payment-${type}`}
//                         name="paymentStructure"
//                         value={type}
//                         checked={paymentStructure === type}
//                         onChange={(e) => setPaymentStructure(e.target.value)}
//                         className="aspect-square h-4 w-4 rounded-full border border-primary text-sm-primary focus:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
//                       />
//                       <Label htmlFor={`payment-${type}`} className="text-sm cursor-pointer">
//                         {type === "Milestone" ? "Milestone Based" : type === "Monthly" ? "Monthly Running Bill" : "Fixed Price(Custom)"}
//                       </Label>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* Milestone Based */}
//               {paymentStructure === "Milestone" && (
//                 <div className="space-y-4">
//                   <div className="rounded-lg border bg-white text-card-foreground shadow-sm">
//                     <div className="p-0">
//                       <table className="w-full caption-bottom text-sm">
//                         <thead className="[&_tr]:border-b">
//                           <tr className="border-b transition-colors hover:bg-transparent">
//                             <th className="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs w-[80px]">Milestone</th>
//                             <th className="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs">Description</th>
//                             <th className="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs w-[120px]">%</th>
//                             <th className="h-10 px-4 align-middle font-medium text-muted-foreground text-xs w-[100px] text-right">Value</th>
//                             <th className="h-10 px-4 align-middle font-medium text-muted-foreground text-xs w-[100px] text-center">Status</th>
//                             <th className="h-10 px-4 align-middle font-medium text-muted-foreground w-[40px]"></th>
//                           </tr>
//                         </thead>
//                         <tbody className="[&_tr:last-child]:border-0">
//                           {milestones.map(milestone => (
//                             <tr key={milestone.id} className="border-b transition-colors hover:bg-muted/30">
//                               <td className="p-2 align-middle">
//                                 <input
//                                   value={milestone.name}
//                                   onChange={(e) => handleMilestoneChange(milestone.id, "name", e.target.value)}
//                                   className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
//                                 />
//                               </td>
//                               <td className="p-2 align-middle">
//                                 <input
//                                   value={milestone.description}
//                                   onChange={(e) => handleMilestoneChange(milestone.id, "description", e.target.value)}
//                                   className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
//                                   placeholder="Description"
//                                 />
//                               </td>
//                               <td className="p-2 align-middle">
//                                 <input
//                                   type="number"
//                                   value={milestone.percentage || ""}
//                                   onChange={(e) => handleMilestoneChange(milestone.id, "percentage", Number(e.target.value))}
//                                   className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
//                                   max={100}
//                                 />
//                               </td>
//                               <td className="p-2 align-middle text-right text-sm font-medium">
//                                 {formatCurrency((grandTotal * milestone.percentage) / 100)}
//                               </td>
//                               <td className="p-2 align-middle text-center">
//                                 <span className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-xs bg-sm-accent/10 text-sm-accent border-sm-accent/30">
//                                   Pending
//                                 </span>
//                               </td>
//                               <td className="p-2 align-middle">
//                                 <Button
//                                   variant="ghost"
//                                   size="icon"
//                                   className="h-7 w-7"
//                                   onClick={() => removeMilestone(milestone.id)}
//                                   disabled={milestones.length === 1}
//                                 >
//                                   <Trash2 className="h-3.5 w-3.5 text-destructive" />
//                                 </Button>
//                               </td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>

//                   <div className="flex items-center justify-between">
//                     <Button variant="ghost" onClick={addMilestone} className="text-sm-primary text-sm gap-2">
//                       <Plus className="h-4 w-4" />
//                       Add Milestone
//                     </Button>
//                     <div className={cn(
//                       "text-sm font-medium",
//                       totalMilestonePercent === 100 ? "text-green-600" : "text-destructive"
//                     )}>
//                       Total: {totalMilestonePercent}% {totalMilestonePercent !== 100 && "(must equal 100%)"}
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Monthly Running Bill */}
//               {paymentStructure === "Monthly" && (
//                 <div className="space-y-4">
//                   <div className="grid grid-cols-2 gap-4">
//                     {/* <div className="space-y-2">
//                       <Label className="text-xs">Estimated Monthly Payment</Label>
//                       <Input
//                         type="number"
//                         value={monthlyValue || ""}
//                         onChange={(e) => setMonthlyValue(Number(e.target.value))}
//                         className="h-9 text-sm"
//                         placeholder="₹0"
//                       />
//                     </div> */}
//                     {/* <div className="space-y-2">
//                       <Label className="text-xs">Retention % (Optional)</Label>
//                       <Input
//                         type="number"
//                         value={retentionPercent || ""}
//                         onChange={(e) => setRetentionPercent(Number(e.target.value))}
//                         className="h-9 text-sm"
//                         max={100}
//                       />
//                     </div> */}
//                   </div>

//                   <div className="rounded-lg border bg-muted/30 border-border/60 p-4">
//                     <div className="flex justify-between text-sm">
//                       <span className="text-muted-foreground">Total Duration:</span>
//                       <span className="font-medium">{durationMonths} Months</span>
//                     </div>
//                     <div className="flex justify-between text-sm mt-2">
//                       <span className="text-muted-foreground">Approx. Payment per Month:</span>
//                       <span className="font-medium">{formatCurrency(monthlyValue || grandTotal / (durationMonths || 1))}</span>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Lumpsum */}
//               {paymentStructure === "Fixed Price" && (
//                 <div className="space-y-4">
//                   <div className="grid grid-cols-2 gap-4">
//                     <div className="space-y-2">
//                       <Label className="text-xs">Total Contract Value</Label>
//                       <div className="h-9 px-3 flex items-center bg-muted/50 rounded-md border text-sm font-medium">
//                         {formatCurrency(grandTotal)}
//                       </div>
//                     </div>
//                     {/* <div className="space-y-2">
//                       <Label className="text-xs">Retention % (Optional)</Label>
//                       <Input
//                         type="number"
//                         value={retentionPercent || ""}
//                         onChange={(e) => setRetentionPercent(Number(e.target.value))}
//                         className="h-9 text-sm"
//                         max={100}
//                       />
//                     </div> */}
//                   </div>
//                   <div className="space-y-2">
//                     <Label className="text-xs">Payment Terms</Label>
//                     <input
//                       value={paymentTerms}
//                       onChange={(e) => setPaymentTerms(e.target.value)}
//                       className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
//                       placeholder="e.g., 50% Advance, 50% Completion"
//                     />
//                   </div>
//                 </div>
//               )}

//               {/* Common Fields */}
//               {/* <div className="pt-4 border-t space-y-4">
//                 <div className="grid grid-cols-2 gap-4">
//                   <div className="space-y-2">
//                     <Label className="text-xs">Payment Start Date</Label>
//                     <div className="relative">
//                       <input
//                         type="date"
//                         className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
//                         value={paymentStartDate}
//                         onChange={(e) => setPaymentStartDate(e.target.value)}
//                       />
//                     </div>
//                   </div>
//                   <div className="space-y-2">
//                     <Label className="text-xs">Payment Mode Preference</Label>
//                     <select
//                       className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
//                       value={paymentMode}
//                       onChange={(e) => setPaymentMode(e.target.value)}
//                     >
//                       <option value="Bank Transfer">Bank Transfer</option>
//                       <option value="UPI">UPI</option>
//                       <option value="Cheque">Cheque</option>
//                       <option value="Cash">Cash</option>
//                     </select>
//                   </div>
//                 </div>
//               </div> */}
//             </div>
//           )}

//           {/* Step 4 - Approval */}
//           {currentStep === 4 && (
//             <div className="space-y-6">
//               <div className="bg-muted/30 rounded-lg p-4 border border-border/50">
//                 <h3 className="text-sm font-semibold mb-3">Review Work Order</h3>
//                 <div className="grid grid-cols-2 gap-y-3 gap-x-8 text-sm">
//                   <div className="flex justify-between">
//                     <span className="text-muted-foreground">Contractor:</span>
//                     <span className="font-medium">{contractors.find(c => c.id === selectedContractor)?.name}</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-muted-foreground">Project:</span>
//                     <span className="font-medium">{sites.find(p => p.id === Number(selectedProject) || p.id === selectedProject)?.site_name}</span>
//                   </div>
//                   {/* <div className="flex justify-between">
//                     <span className="text-muted-foreground">Contract Type:</span>
//                     <span className="font-medium">{contractType}</span>
//                   </div> */}
//                   <div className="flex justify-between">
//                     <span className="text-muted-foreground">Total Value:</span>
//                     <span className="font-semibold text-sm-primary">{formatCurrency(grandTotal)}</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-muted-foreground">Start Date:</span>
//                     <span className="font-medium">{startDate ? format(new Date(startDate), "PPP") : "-"}</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-muted-foreground">End Date:</span>
//                     <span className="font-medium">{endDate ? format(new Date(endDate), "PPP") : "-"}</span>
//                   </div>
//                 </div>
//               </div>

//               <div className="space-y-4">
//                 <div className="flex items-start space-x-2">
//                   <input
//                     type="checkbox"
//                     id="terms"
//                     checked={acknowledged}
//                     onChange={(e) => {
//                       setAcknowledged(e.target.checked);
//                       if (e.target.checked) setAcknowledgmentDate(new Date().toISOString());
//                     }}
//                     className="h-4 w-4 rounded border-primary text-sm-primary focus:ring-1 focus:ring-ring"
//                   />
//                   <div className="grid gap-1.5 leading-none">
//                     <Label
//                       htmlFor="terms"
//                       className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
//                     >
//                       Acknowledge Work Order
//                     </Label>
//                     <p className="text-xs text-muted-foreground">
//                       By checking this, you confirm that you have reviewed the scope, payment terms, and project details.
//                     </p>
//                   </div>
//                 </div>

//                 {acknowledged && (
//                   <div className="flex items-center gap-2 text-sm text-muted-foreground bg-muted/20 p-2 rounded">
//                     <CheckCircle2 className="h-4 w-4 text-green-600" />
//                     Acknowledged on {format(new Date(), "PPP")}
//                   </div>
//                 )}
//               </div>

//               <div className="flex items-center gap-2 p-3 bg-yellow-500/10 text-yellow-700 rounded-lg text-xs">
//                 <AlertCircle className="h-4 w-4" />
//                 This work order will be sent to the contractor for final digital signature.
//               </div>
//             </div>
//           )}
//         </div>

//         <div className="flex items-center justify-between p-4 border-t bg-muted/10 mt-auto">
//           <div className="flex items-center gap-3 w-full">
//             {apiError && (
//               <div className="flex items-center gap-2 text-destructive text-sm font-medium mr-auto">
//                 <AlertCircle className="h-4 w-4" />
//                 {apiError}
//               </div>
//             )}
//             {validationError && (
//               <div className="flex items-center gap-2 text-destructive text-sm font-medium mr-auto animate-in fade-in slide-in-from-left-2 duration-200">
//                 <AlertCircle className="h-4 w-4" />
//                 {validationError}
//               </div>
//             )}

//             <div className="flex-1" />
//             <Button
//               variant="outline"
//               onClick={currentStep === 1 ? handleClose : handleBack}
//               disabled={isSubmitting}
//             >
//               {currentStep === 1 ? "Cancel" : "Back"}
//             </Button>
//             <Button
//               onClick={currentStep === 4 ? handleSubmit : handleNext}
//               disabled={
//                 isSubmitting ||
//                 (currentStep === 4 && !acknowledged) ||
//                 (currentStep === 3 && paymentStructure === "Milestone" && totalMilestonePercent !== 100)
//               }
//               className="bg-sm-primary hover:bg-sm-primary/90 min-w-[100px]"
//             >
//               {isSubmitting ? (
//                 <div className="h-4 w-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
//               ) : currentStep === 4 ? (
//                 "Create Work Order"
//               ) : (
//                 "Next Step"
//               )}
//             </Button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import { useState, useEffect } from "react";
import { WorkOrderApi } from "api/workorders/service";
import { ProjectApi } from "api/projects/service";
import { format } from "date-fns";
import {
  Calendar as CalendarIcon,
  Plus,
  Trash2,
  Upload,
  FileText,
  Check,
  CheckCircle2,
  AlertCircle,
  IndianRupee,
  PartyPopper,
  X,
} from "lucide-react";

const cn = (...classes) => classes.filter(Boolean).join(" ");

const STEPS = [
  { id: 1, name: "Basic Info", icon: FileText },
  { id: 2, name: "Scope", icon: FileText },
  { id: 3, name: "Payment", icon: IndianRupee },
  { id: 4, name: "Approval", icon: Check },
];

export function CreateWorkOrderDialog({
  open,
  onOpenChange,
  contractors,
  selectedContractorId,
  onCreateWorkOrder,
  onViewWorkOrder,
}) {
  const [currentStep, setCurrentStep] = useState(1);
  const [showSuccess, setShowSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [sites, setSites] = useState([]);
  const [validationError, setValidationError] = useState(null);
  const [createdWorkOrder, setCreatedWorkOrder] = useState(null);


  // Step 1 - Basic Info
  const [selectedContractor, setSelectedContractor] = useState(selectedContractorId || "");
  const [selectedProject, setSelectedProject] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [contractType, setContractType] = useState("Lumpsum");

  const [scopeItems, setScopeItems] = useState([
    {
      id: "1",
      item: "",
      description: "",
      quantity: 0,
      unit: "Nos",
      unitCost: 0,
      totalCost: 0,
    },
  ]);
  const [scopeNotes, setScopeNotes] = useState("");

  const [paymentStructure, setPaymentStructure] = useState("Milestone");
  const [milestones, setMilestones] = useState([
    {
      id: "1",
      name: "M1",
      description: "",
      percentage: 100,
      value: 0,
      status: "Pending",
    },
  ]);
  const [monthlyValue, setMonthlyValue] = useState(0);
  const [retentionPercent, setRetentionPercent] = useState(0);
  const [paymentTerms, setPaymentTerms] = useState("");
  const [paymentMode, setPaymentMode] = useState("Bank Transfer");
  const [paymentStartDate, setPaymentStartDate] = useState("");

  const [acknowledged, setAcknowledged] = useState(false);
  const [acknowledgmentDate, setAcknowledgmentDate] = useState("");
  const [attachment, setAttachment] = useState(null);

  const organization = JSON.parse(localStorage.getItem("organization")) || {};

  useEffect(() => {
    const fetchSites = async () => {
      if (!organization?.id) return;
      try {
        const response = await ProjectApi.listSitesByOrganization(
          organization.id,
        );
        if (response) setSites(response || []);
      } catch (err) {
        console.error("Error fetching sites:", err);
      }
    };
    if (open) fetchSites();
  }, [open, organization.id]);

  const grandTotal = scopeItems.reduce((sum, item) => sum + item.totalCost, 0);
  const totalMilestonePercent = milestones.reduce(
    (sum, m) => sum + m.percentage,
    0,
  );

  const generateWorkOrderRef = () => {
    const project = sites.find((p) => p.id === selectedProject);
    const projectName = project?.site_name?.replace(/\s+/g, "_") || "Project";
    return `WO_${projectName}_${Date.now().toString().slice(-4)}`;
  };

  // ADDED: blocks '-', 'e', 'E' key input on number fields
  const blockNegativeInput = (e) => {
    if (e.key === "-" || e.key === "e" || e.key === "E") {
      e.preventDefault();
    }
  };

  const handleScopeItemChange = (id, field, value) => {
    setScopeItems((items) =>
      items.map((item) => {
        if (item.id === id) {
          const sanitized =
            field === "quantity" || field === "unitCost"
              ? Math.max(0, Number(value))
              : value;
          const updated = { ...item, [field]: sanitized };
          if (field === "quantity" || field === "unitCost") {
            updated.totalCost = updated.quantity * updated.unitCost;
          }
          return updated;
        }
        return item;
      }),
    );
  };

  const addScopeItem = () => {
    setScopeItems([
      ...scopeItems,
      {
        id: Date.now().toString(),
        item: "",
        description: "",
        quantity: 0,
        unit: "Nos",
        unitCost: 0,
        totalCost: 0,
      },
    ]);
  };

  const removeScopeItem = (id) => {
    if (scopeItems.length > 1)
      setScopeItems(scopeItems.filter((item) => item.id !== id));
  };

  const handleMilestoneChange = (id, field, value) => {
    setMilestones((items) =>
      items.map((item) => {
        if (item.id === id) {
          const updated = { ...item, [field]: value };
          if (field === "percentage") {
            updated.value = (grandTotal * Number(value)) / 100;
          }
          return updated;
        }
        return item;
      }),
    );
  };

  const addMilestone = () => {
    const currentLength = milestones.length;
    const newIndex = currentLength + 1;

    if (currentLength === 0) {
      setMilestones([
        {
          id: Date.now().toString(),
          name: "M1",
          description: "",
          percentage: 100,
          value: grandTotal,
          status: "Pending",
        },
      ]);
      return;
    }

    const ratio = currentLength / newIndex;
    const updatedMilestones = milestones.map((m) => {
      const newPercentage = Math.round(m.percentage * ratio);
      return {
        ...m,
        percentage: newPercentage,
        value: (grandTotal * newPercentage) / 100,
      };
    });

    const currentSum = updatedMilestones.reduce(
      (sum, m) => sum + m.percentage,
      0,
    );
    const newPercentage = 100 - currentSum;

    setMilestones([
      ...updatedMilestones,
      {
        id: Date.now().toString(),
        name: `M${newIndex}`,
        description: "",
        percentage: newPercentage,
        value: (grandTotal * newPercentage) / 100,
        status: "Pending",
      },
    ]);
  };

  const removeMilestone = (id) => {
    if (milestones.length > 1)
      setMilestones(milestones.filter((m) => m.id !== id));
  };

  const handleNext = () => {
    setValidationError(null);
    setApiError(null);

    if (currentStep === 1) {
      if (!startDate || !endDate) {
        setValidationError("Please select both Start and End dates.");
        return;
      }
      if (!selectedProject) {
        setValidationError("Please select a Project before proceeding.");
        return;
      }
    }

    if (currentStep === 2) {
      const hasValidItem = scopeItems.some(
        (item) => item.item && item.totalCost > 0,
      );
      if (!hasValidItem) {
        setValidationError(
          "Please add at least one scope item with a positive total.",
        );
        return;
      }
    }

    if (currentStep < 4) setCurrentStep(currentStep + 1);
  };

  const handleBack = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    setApiError(null);

    try {
      const formData = new FormData();

      const paymentStructureMap = {
        Milestone: "MILESTONE_BASED",
        Monthly: "MONTHLY_RUNNING_BILL",
        "Fixed Price": "LUMPSUM_CUSTOM",
      };

      const contractTypeMap = {
        Labour: "LABOUR",
        "Item Rate": "ITEM_RATE",
        Lumpsum: "LUMPSUM",
      };

      formData.append("contractor", selectedContractor);
      formData.append("site", selectedProject);
      formData.append("start_date", startDate);
      formData.append("end_date", endDate);
      formData.append(
        "contract_type",
        contractTypeMap[contractType] || contractType,
      );
      formData.append("scope_notes", scopeNotes);
      formData.append(
        "payment_structure",
        paymentStructureMap[paymentStructure] || paymentStructure,
      );
      formData.append("payment_terms", paymentTerms);
      formData.append("terms_and_conditions", "");
      formData.append("date_of_issue", new Date().toISOString().split("T")[0]);
      formData.append("is_acknowledged", acknowledged);

      const mappedScopeItems = scopeItems.map((item) => ({
        item_name: item.item,
        description: item.description,
        quantity: item.quantity,
        unit: item.unit.toLowerCase().replace(" ", "_"),
        unit_cost: item.unitCost,
        total_price: item.totalCost,
      }));
      formData.append("scope_items", JSON.stringify(mappedScopeItems));

      if (paymentStructure === "Milestone" || paymentStructure === "Lumpsum") {
        const mappedMilestones = milestones.map((m) => ({
          name: m.name,
          description: m.description,
          amount: (grandTotal * m.percentage) / 100,
        }));
        formData.append("milestones", JSON.stringify(mappedMilestones));
      }

      if (attachment) formData.append("attachments", attachment);

      const response = await WorkOrderApi.create(formData);

      if (response.status) {
        const responseData = response?.data || response;
        const project = sites.find(p => String(p.id) === String(selectedProject));
        const workorderId = responseData?.workorder_id ?? responseData?.id ?? responseData?.work_order_id;
        const workorderNo = responseData?.workorder_no ?? responseData?.work_order_no ?? responseData?.workorder_number ?? generateWorkOrderRef();
        setCreatedWorkOrder({
          id: workorderNo,
          workorder_id: workorderId,
          contractorId: selectedContractor,
          projectName: project?.site_name,
          startDate,
          endDate,
          paymentStructure,
          value: grandTotal,
          status: "Active",
          paidAmount: 0,
          milestones: [],
        });
        onCreateWorkOrder(selectedContractor);
        setShowSuccess(true);
      } else {
        setApiError(response.message || "Failed to create work order");
      }
    } catch (err) {
      console.error("Error creating work order:", err);
      setApiError(err.message || "An unexpected error occurred");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setCurrentStep(1);
    setShowSuccess(false);
    setApiError(null);
    setIsSubmitting(false);
    setCreatedWorkOrder(null);
    setSelectedContractor(selectedContractorId || "");
    setSelectedProject("");
    setStartDate("");
    setEndDate("");
    setContractType("Lumpsum");
    setScopeItems([
      {
        id: "1",
        item: "",
        description: "",
        quantity: 0,
        unit: "Nos",
        unitCost: 0,
        totalCost: 0,
      },
    ]);
    setPaymentStructure("Milestone");
    setAcknowledged(false);
    onOpenChange(false);
  };

  const handleViewCreatedWorkOrder = () => {
    if (createdWorkOrder && onViewWorkOrder) {
      onViewWorkOrder(createdWorkOrder);
    }
    handleClose();
  };

  const formatCurrency = (amount) => {
    if (amount >= 100000) return `₹${(amount / 100000).toFixed(2)}L`;
    return `₹${amount.toLocaleString()}`;
  };

  const durationMonths =
    startDate && endDate
      ? Math.ceil(
        (new Date(endDate).getTime() - new Date(startDate).getTime()) /
        (1000 * 60 * 60 * 24 * 30),
      )
      : 0;

  const Label = ({ children, className = "" }) => (
    <label
      className={`text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 ${className}`}
    >
      {children}
    </label>
  );

  const Input = ({ className = "", ...props }) => (
    <input
      className={`flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
      {...props}
    />
  );

  const Button = ({
    variant = "default",
    size = "default",
    className = "",
    children,
    ...props
  }) => {
    const baseStyles =
      "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50";
    const variants = {
      default: "bg-sm-primary text-white shadow hover:bg-sm-primary/90",
      destructive:
        "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
      outline:
        "border border-input bg-transparent shadow-sm hover:bg-sm-accent hover:text-sm-accent-foreground",
      secondary:
        "bg-sm-secondary text-sm-secondary-foreground shadow-sm hover:bg-sm-secondary/80",
      ghost: "hover:bg-sm-accent hover:text-sm-accent-foreground",
      link: "text-sm-primary underline-offset-4 hover:underline",
    };
    const sizes = {
      default: "h-9 px-4 py-2",
      sm: "h-8 rounded-md px-3 text-xs",
      lg: "h-10 rounded-md px-8",
      icon: "h-9 w-9",
    };
    return (
      <button
        className={cn(baseStyles, variants[variant], sizes[size], className)}
        {...props}
      >
        {children}
      </button>
    );
  };

  if (!open) return null;

  if (showSuccess) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80">
        <div className="relative w-full max-w-md rounded-lg border bg-background p-6 shadow-lg animate-in fade-in-0 zoom-in-95 duration-200">
          <button
            onClick={handleClose}
            className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none"
          >
            <X className="h-4 w-4" />
            <span className="sr-only">Close</span>
          </button>
          <div className="flex flex-col items-center justify-center py-8 text-center">
            <div className="h-16 w-16 rounded-full bg-sm-primary/10 flex items-center justify-center mb-4">
              <PartyPopper className="h-8 w-8 text-sm-primary" />
            </div>
            <h2 className="text-xl font-semibold mb-2">
              Work Order Created Successfully!
            </h2>
            <p className="text-muted-foreground text-sm mb-6">
              Work Order #{createdWorkOrder?.id || generateWorkOrderRef()} has been activated.
            </p>
            <div className="flex gap-3">
              <Button variant="outline" onClick={handleClose}>
                Go to Dashboard
              </Button>
              <Button onClick={handleViewCreatedWorkOrder} className="bg-sm-primary hover:bg-sm-primary/90">
                View Work Order
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80">
      <div className="relative w-full max-w-4xl max-h-[90vh] flex flex-col rounded-lg border bg-background shadow-lg animate-in fade-in-0 zoom-in-95 duration-200">
        <div className="flex flex-col space-y-1.5 p-6 pb-4 border-b">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-semibold leading-none tracking-tight">
              Create Work Order
            </h3>
            <button
              onClick={handleClose}
              className="rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none"
            >
              <X className="h-4 w-4" />
              <span className="sr-only">Close</span>
            </button>
          </div>

          <div className="flex items-start justify-between mt-4 px-12">
            {STEPS.map((step, index) => (
              <div
                key={step.id}
                className={cn(
                  "flex items-center",
                  index < STEPS.length - 1 ? "flex-1" : "",
                )}
              >
                <div className="flex flex-col items-center relative">
                  <div
                    className={cn(
                      "h-8 w-8 rounded-full flex items-center justify-center text-xs font-medium transition-colors relative z-10",
                      currentStep > step.id
                        ? "bg-sm-primary text-white"
                        : currentStep === step.id
                          ? "bg-sm-secondary text-white"
                          : "bg-muted text-muted-foreground",
                    )}
                  >
                    {currentStep > step.id ? (
                      <Check className="h-4 w-4" />
                    ) : (
                      step.id
                    )}
                  </div>
                  <span
                    className={cn(
                      "text-[10px] mt-1 absolute top-8 whitespace-nowrap",
                      currentStep >= step.id
                        ? "text-foreground"
                        : "text-muted-foreground",
                    )}
                  >
                    {step.name}
                  </span>
                </div>
                {index < STEPS.length - 1 && (
                  <div
                    className={cn(
                      "flex-1 h-0.5 -mt-1",
                      currentStep > step.id ? "bg-sm-primary" : "bg-border",
                    )}
                  />
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="flex-1 overflow-y-auto py-4 px-6">
          {/* Step 1 */}
          {currentStep === 1 && (
            <div className="space-y-6">
              <div className="space-y-1">
                <h3 className="text-sm font-medium text-muted-foreground">
                  Work Order Details
                </h3>
                <div className="grid grid-cols-2 gap-4 pt-2">
                  <div className="space-y-2">
                    <Label className="text-xs">Select Contractor</Label>
                    <select
                      className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                      value={selectedContractor}
                      onChange={(e) => setSelectedContractor(e.target.value)}
                    >
                      <option value="" disabled>
                        Choose contractor
                      </option>
                      {contractors.map((contractor) => (
                        <option key={contractor.id} value={contractor.id}>
                          {contractor.name} ({contractor.category})
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="space-y-2">
                    <Label className="text-xs">Select Project</Label>
                    <select
                      className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                      value={selectedProject}
                      onChange={(e) => setSelectedProject(e.target.value)}
                    >
                      <option value="" disabled>
                        Choose project
                      </option>
                      {sites.map((site) => (
                        <option key={site.id} value={site.id}>
                          {site.site_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="space-y-1">
                <h3 className="text-sm font-medium text-muted-foreground">
                  Duration
                </h3>
                <div className="grid grid-cols-2 gap-4 pt-2">
                  <div className="space-y-2">
                    <Label className="text-xs">Start Date</Label>
                    <input
                      type="date"
                      className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label className="text-xs">End Date</Label>
                    <input
                      type="date"
                      className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Step 2 - Scope & Items */}
          {currentStep === 2 && (
            <div className="space-y-4">
              <div className="space-y-1">
                <h3 className="text-sm font-medium text-muted-foreground">
                  Scope Items
                </h3>
              </div>

              <div className="rounded-lg border bg-white text-card-foreground shadow-sm">
                <div className="p-0">
                  <table className="w-full caption-bottom text-sm">
                    <thead className="[&_tr]:border-b">
                      <tr className="border-b transition-colors hover:bg-transparent">
                        <th className="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs w-[140px]">
                          Item
                        </th>
                        <th className="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs">
                          Description
                        </th>
                        <th className="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs w-[100px]">
                          Qty
                        </th>
                        <th className="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs w-[100px]">
                          Unit
                        </th>
                        <th className="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs w-[100px]">
                          Unit Cost
                        </th>
                        <th className="h-10 px-4 align-middle font-medium text-muted-foreground text-xs w-[80px] text-right">
                          Total
                        </th>
                        <th className="h-10 px-4 text-left align-middle font-medium text-muted-foreground w-[40px]"></th>
                      </tr>
                    </thead>
                    <tbody className="[&_tr:last-child]:border-0">
                      {scopeItems.map((item) => (
                        <tr
                          key={item.id}
                          className="border-b transition-colors hover:bg-muted/30"
                        >
                          <td className="p-2 align-middle">
                            <input
                              value={item.item}
                              onChange={(e) =>
                                handleScopeItemChange(
                                  item.id,
                                  "item",
                                  e.target.value,
                                )
                              }
                              className="flex h-8 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                              placeholder="Item name"
                            />
                          </td>
                          <td className="p-2 align-middle">
                            <input
                              value={item.description}
                              onChange={(e) =>
                                handleScopeItemChange(
                                  item.id,
                                  "description",
                                  e.target.value,
                                )
                              }
                              className="flex h-8 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                              placeholder="Description"
                            />
                          </td>
                          <td className="p-2 align-middle">
                            {/* CHANGED: added min={0} + onKeyDown to block negative input */}
                            <input
                              type="number"
                              min={0}
                              onKeyDown={blockNegativeInput}
                              value={item.quantity || ""}
                              onChange={(e) =>
                                handleScopeItemChange(
                                  item.id,
                                  "quantity",
                                  Number(e.target.value),
                                )
                              }
                              className="flex h-8 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                            />
                          </td>
                          <td className="p-2 align-middle">
                            <select
                              className="flex h-8 w-full rounded-md border border-input bg-background px-3 py-1 text-xs shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                              value={item.unit}
                              onChange={(e) =>
                                handleScopeItemChange(
                                  item.id,
                                  "unit",
                                  e.target.value,
                                )
                              }
                            >
                              <option value="Nos">Nos</option>
                              <option value="Sqft">Sqft</option>
                              <option value="Sqm">Sqm</option>
                              <option value="Rft">Rft</option>
                              <option value="Mtr">Mtr</option>
                              <option value="Ft">Ft</option>
                              <option value="Inch">Inch</option>
                              <option value="Mm">Mm</option>
                              <option value="Cum">Cum</option>
                              <option value="Kg">Kg</option>
                            </select>
                          </td>
                          <td className="p-2 align-middle">
                            {/* CHANGED: added min={0} + onKeyDown to block negative input */}
                            <input
                              type="number"
                              min={0}
                              onKeyDown={blockNegativeInput}
                              value={item.unitCost || ""}
                              onChange={(e) =>
                                handleScopeItemChange(
                                  item.id,
                                  "unitCost",
                                  Number(e.target.value),
                                )
                              }
                              className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                              placeholder="₹0"
                            />
                          </td>
                          <td className="p-2 align-middle text-right text-sm font-medium">
                            {formatCurrency(item.totalCost)}
                          </td>
                          <td className="p-2 align-middle">
                            <Button
                              variant="ghost"
                              size="icon"
                              className="h-7 w-7"
                              onClick={() => removeScopeItem(item.id)}
                              disabled={scopeItems.length === 1}
                            >
                              <Trash2 className="h-3.5 w-3.5 text-destructive" />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <Button
                variant="ghost"
                onClick={addScopeItem}
                className="text-sm-primary text-sm gap-2"
              >
                <Plus className="h-4 w-4" />
                Add Item
              </Button>

              <div className="flex justify-end">
                <div className="bg-sm-primary/5 rounded-lg px-6 py-3 border border-primary/20">
                  <div className="flex items-center gap-3">
                    <span className="text-sm text-muted-foreground">
                      Grand Total:
                    </span>
                    <span className="text-lg font-semibold text-sm-primary">
                      {formatCurrency(grandTotal)}
                    </span>
                  </div>
                </div>
              </div>

              <div className="space-y-2 pt-4 border-t">
                <Label className="text-xs text-muted-foreground">
                  Notes / Special Conditions
                </Label>
                <textarea
                  value={scopeNotes}
                  onChange={(e) => setScopeNotes(e.target.value)}
                  placeholder="Add any special conditions or notes..."
                  className="flex min-h-[80px] w-full rounded-md border border-input bg-transparent px-3 py-2 shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring text-sm h-20"
                />
              </div>

              <div className="flex items-center gap-2 pt-2">
                {!attachment ? (
                  <div className="w-full">
                    <label className="flex flex-col items-center justify-center w-full h-24 border-2 border-dashed border-muted-foreground/25 rounded-lg cursor-pointer hover:bg-muted/30 transition-colors">
                      <div className="flex flex-col items-center justify-center pt-5 pb-6">
                        <Upload className="h-6 w-6 text-muted-foreground mb-2" />
                        <p className="text-xs text-muted-foreground">
                          Click to upload Scope Document (PDF, Image, etc.)
                        </p>
                      </div>
                      <input
                        type="file"
                        className="hidden"
                        onChange={(e) => setAttachment(e.target.files[0])}
                      />
                    </label>
                  </div>
                ) : (
                  <div className="w-full bg-sm-primary/5 border border-sm-primary/20 rounded-lg p-3">
                    <div className="flex items-center gap-4">
                      {attachment.type.startsWith("image/") ? (
                        <div className="h-16 w-16 rounded border bg-white overflow-hidden flex-shrink-0">
                          <img
                            src={URL.createObjectURL(attachment)}
                            alt="Preview"
                            className="h-full w-full object-cover"
                          />
                        </div>
                      ) : (
                        <div className="h-16 w-16 rounded border bg-white flex items-center justify-center flex-shrink-0">
                          <FileText className="h-8 w-8 text-sm-primary/40" />
                        </div>
                      )}
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium truncate">
                          {attachment.name}
                        </p>
                        <p className="text-xs text-muted-foreground mt-0.5">
                          {(attachment.size / (1024 * 1024)).toFixed(2)} MB •{" "}
                          {attachment.type.split("/")[1]?.toUpperCase() ||
                            "File"}
                        </p>
                        <div className="flex items-center gap-2 mt-2">
                          <span className="flex items-center gap-1 text-[10px] text-green-600 bg-green-50 px-1.5 py-0.5 rounded border border-green-100 font-medium">
                            <Check className="h-3 w-3" /> Uploaded Successfully
                          </span>
                        </div>
                      </div>
                      <Button
                        variant="ghost"
                        size="icon"
                        className="h-8 w-8 text-muted-foreground hover:text-destructive"
                        onClick={() => setAttachment(null)}
                      >
                        <X className="h-4 w-4" />
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Step 3 - Payment Structure */}
          {currentStep === 3 && (
            <div className="space-y-6">
              <div className="space-y-1">
                <h3 className="text-sm font-medium text-muted-foreground">
                  Payment Structure Type
                </h3>
                <div className="flex gap-4 pt-2">
                  {["Milestone", "Monthly", "Fixed Price"].map((type) => (
                    <div
                      key={type}
                      className={cn(
                        "flex items-center space-x-2 border rounded-lg px-4 py-2 cursor-pointer transition-colors",
                        paymentStructure === type
                          ? "border-primary bg-sm-primary/5"
                          : "border-border",
                      )}
                      onClick={() => setPaymentStructure(type)}
                    >
                      <input
                        type="radio"
                        id={`payment-${type}`}
                        name="paymentStructure"
                        value={type}
                        checked={paymentStructure === type}
                        onChange={(e) => setPaymentStructure(e.target.value)}
                        className="aspect-square h-4 w-4 rounded-full border border-primary text-sm-primary focus:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                      />
                      <Label
                        htmlFor={`payment-${type}`}
                        className="text-sm cursor-pointer"
                      >
                        {type === "Milestone"
                          ? "Milestone Based"
                          : type === "Monthly"
                            ? "Monthly Running Bill"
                            : "Fixed Price(Custom)"}
                      </Label>
                    </div>
                  ))}
                </div>
              </div>

              {paymentStructure === "Milestone" && (
                <div className="space-y-4">
                  <div className="rounded-lg border bg-white text-card-foreground shadow-sm">
                    <div className="p-0">
                      <table className="w-full caption-bottom text-sm">
                        <thead className="[&_tr]:border-b">
                          <tr className="border-b transition-colors hover:bg-transparent">
                            <th className="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs w-[80px]">
                              Milestone
                            </th>
                            <th className="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs">
                              Description
                            </th>
                            <th className="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs w-[120px]">
                              %
                            </th>
                            <th className="h-10 px-4 align-middle font-medium text-muted-foreground text-xs w-[100px] text-right">
                              Value
                            </th>
                            <th className="h-10 px-4 align-middle font-medium text-muted-foreground text-xs w-[100px] text-center">
                              Status
                            </th>
                            <th className="h-10 px-4 align-middle font-medium text-muted-foreground w-[40px]"></th>
                          </tr>
                        </thead>
                        <tbody className="[&_tr:last-child]:border-0">
                          {milestones.map((milestone) => (
                            <tr
                              key={milestone.id}
                              className="border-b transition-colors hover:bg-muted/30"
                            >
                              <td className="p-2 align-middle">
                                <input
                                  value={milestone.name}
                                  onChange={(e) =>
                                    handleMilestoneChange(
                                      milestone.id,
                                      "name",
                                      e.target.value,
                                    )
                                  }
                                  className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                                />
                              </td>
                              <td className="p-2 align-middle">
                                <input
                                  value={milestone.description}
                                  onChange={(e) =>
                                    handleMilestoneChange(
                                      milestone.id,
                                      "description",
                                      e.target.value,
                                    )
                                  }
                                  className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                                  placeholder="Description"
                                />
                              </td>
                              <td className="p-2 align-middle">
                                <input
                                  type="number"
                                  value={milestone.percentage || ""}
                                  onChange={(e) =>
                                    handleMilestoneChange(
                                      milestone.id,
                                      "percentage",
                                      Number(e.target.value),
                                    )
                                  }
                                  className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                                  max={100}
                                />
                              </td>
                              <td className="p-2 align-middle text-right text-sm font-medium">
                                {formatCurrency(
                                  (grandTotal * milestone.percentage) / 100,
                                )}
                              </td>
                              <td className="p-2 align-middle text-center">
                                <span className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors text-xs bg-sm-accent/10 text-sm-accent border-sm-accent/30">
                                  Pending
                                </span>
                              </td>
                              <td className="p-2 align-middle">
                                <Button
                                  variant="ghost"
                                  size="icon"
                                  className="h-7 w-7"
                                  onClick={() => removeMilestone(milestone.id)}
                                  disabled={milestones.length === 1}
                                >
                                  <Trash2 className="h-3.5 w-3.5 text-destructive" />
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="flex items-center justify-between">
                    <Button
                      variant="ghost"
                      onClick={addMilestone}
                      className="text-sm-primary text-sm gap-2"
                    >
                      <Plus className="h-4 w-4" />
                      Add Milestone
                    </Button>
                    <div
                      className={cn(
                        "text-sm font-medium",
                        totalMilestonePercent === 100
                          ? "text-green-600"
                          : "text-destructive",
                      )}
                    >
                      Total: {totalMilestonePercent}%{" "}
                      {totalMilestonePercent !== 100 && "(must equal 100%)"}
                    </div>
                  </div>
                </div>
              )}

              {paymentStructure === "Monthly" && (
                <div className="space-y-4">
                  <div className="rounded-lg border bg-muted/30 border-border/60 p-4">
                    <div className="flex justify-between text-sm">
                      <span className="text-muted-foreground">
                        Total Duration:
                      </span>
                      <span className="font-medium">
                        {durationMonths} Months
                      </span>
                    </div>
                    <div className="flex justify-between text-sm mt-2">
                      <span className="text-muted-foreground">
                        Approx. Payment per Month:
                      </span>
                      <span className="font-medium">
                        {formatCurrency(
                          monthlyValue || grandTotal / (durationMonths || 1),
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              {paymentStructure === "Fixed Price" && (
                <div className="space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div className="space-y-2">
                      <Label className="text-xs">Total Contract Value</Label>
                      <div className="h-9 px-3 flex items-center bg-muted/50 rounded-md border text-sm font-medium">
                        {formatCurrency(grandTotal)}
                      </div>
                    </div>
                  </div>
                  <div className="space-y-2">
                    <Label className="text-xs">Payment Terms</Label>
                    <input
                      value={paymentTerms}
                      onChange={(e) => setPaymentTerms(e.target.value)}
                      className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                      placeholder="e.g., 50% Advance, 50% Completion"
                    />
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Step 4 - Approval */}
          {currentStep === 4 && (
            <div className="space-y-6">
              <div className="bg-muted/30 rounded-lg p-4 border border-border/50">
                <h3 className="text-sm font-semibold mb-3">
                  Review Work Order
                </h3>
                <div className="grid grid-cols-2 gap-y-3 gap-x-8 text-sm">
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Contractor:</span>
                    <span className="font-medium">
                      {
                        contractors.find((c) => c.id === selectedContractor)
                          ?.name
                      }
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Project:</span>
                    <span className="font-medium">
                      {
                        sites.find(
                          (p) =>
                            p.id === Number(selectedProject) ||
                            p.id === selectedProject,
                        )?.site_name
                      }
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Total Value:</span>
                    <span className="font-semibold text-sm-primary">
                      {formatCurrency(grandTotal)}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Start Date:</span>
                    <span className="font-medium">
                      {startDate ? format(new Date(startDate), "PPP") : "-"}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">End Date:</span>
                    <span className="font-medium">
                      {endDate ? format(new Date(endDate), "PPP") : "-"}
                    </span>
                  </div>
                </div>
              </div>

              <div className="space-y-4">
                <div className="flex items-start space-x-2">
                  <input
                    type="checkbox"
                    id="terms"
                    checked={acknowledged}
                    onChange={(e) => {
                      setAcknowledged(e.target.checked);
                      if (e.target.checked)
                        setAcknowledgmentDate(new Date().toISOString());
                    }}
                    className="h-4 w-4 rounded border-primary text-sm-primary focus:ring-1 focus:ring-ring"
                  />
                  <div className="grid gap-1.5 leading-none">
                    <Label
                      htmlFor="terms"
                      className="text-sm font-medium leading-none"
                    >
                      Acknowledge Work Order
                    </Label>
                    <p className="text-xs text-muted-foreground">
                      By checking this, you confirm that you have reviewed the
                      scope, payment terms, and project details.
                    </p>
                  </div>
                </div>
                {acknowledged && (
                  <div className="flex items-center gap-2 text-sm text-muted-foreground bg-muted/20 p-2 rounded">
                    <CheckCircle2 className="h-4 w-4 text-green-600" />
                    Acknowledged on {format(new Date(), "PPP")}
                  </div>
                )}
              </div>

              <div className="flex items-center gap-2 p-3 bg-yellow-500/10 text-yellow-700 rounded-lg text-xs">
                <AlertCircle className="h-4 w-4" />
                This work order will be sent to the contractor for final digital
                signature.
              </div>
            </div>
          )}
        </div>

        <div className="flex items-center justify-between p-4 border-t bg-muted/10 mt-auto">
          <div className="flex items-center gap-3 w-full">
            {apiError && (
              <div className="flex items-center gap-2 text-destructive text-sm font-medium mr-auto">
                <AlertCircle className="h-4 w-4" />
                {apiError}
              </div>
            )}
            {validationError && (
              <div className="flex items-center gap-2 text-destructive text-sm font-medium mr-auto animate-in fade-in slide-in-from-left-2 duration-200">
                <AlertCircle className="h-4 w-4" />
                {validationError}
              </div>
            )}
            <div className="flex-1" />
            <Button
              variant="outline"
              onClick={currentStep === 1 ? handleClose : handleBack}
              disabled={isSubmitting}
            >
              {currentStep === 1 ? "Cancel" : "Back"}
            </Button>
            <Button
              onClick={currentStep === 4 ? handleSubmit : handleNext}
              disabled={
                isSubmitting ||
                (currentStep === 4 && !acknowledged) ||
                (currentStep === 3 &&
                  paymentStructure === "Milestone" &&
                  totalMilestonePercent !== 100)
              }
              className="bg-sm-primary hover:bg-sm-primary/90 min-w-[100px]"
            >
              {isSubmitting ? (
                <div className="h-4 w-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              ) : currentStep === 4 ? (
                "Create Work Order"
              ) : (
                "Next Step"
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
